import { useEffect, useState } from 'react';
import dashboardApis from 'modules/dashboard/services/apis';
import { IScreen } from 'modules/dashboard/interfaces/api';

const useGetAllScreens = (enabled = true, storeId?: string) => {
  const [screens, setScreens] = useState<IScreen[]>([]);
  useEffect(() => {
    if (!enabled) return;

    const handleFetchAllScreens = async () => {
      const res = await dashboardApis.getListScreens({ page: 1, size: 1000, storeId });

      if (res?.data?.data?.content) {
        setScreens(res.data.data.content);
      }
    };

    handleFetchAllScreens();
  }, [enabled]);

  return [screens] as const;
};

export default useGetAllScreens;
